import React, { useEffect } from 'react';
import { JiraSoftwareBoardAri } from '@atlassian/ari/jira-software/board';
import { useBoardId } from '@atlassian/jira-board-settings-common/src/common/utils/use-board-id';
import { useEntryPoint } from '@atlassian/jira-entry-point';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';
import { useResource } from '@atlassian/jira-router';
import { editModelResource } from '@atlassian/jira-router-resources-classic-projects';
import type { RapidBoardConfig } from '@atlassian/jira-software-board-settings-rapidboard-config-common';
import { useCloudId } from '@atlassian/jira-tenant-context-controller';
import { cardLayoutSettingPageEntryPoint } from './entrypoint';

export const CardLayoutSettingsPage = () => {
	const { data } = useResource(editModelResource);

	if (!data) {
		return null;
	}

	return <CardLayoutSettingsContent {...data} />;
};

const CardLayoutSettingsContent = (props: RapidBoardConfig) => {
	const boardId = useBoardId();
	const cloudId = useCloudId();

	const boardAri = JiraSoftwareBoardAri.create({
		siteId: cloudId,
		boardId: String(boardId),
	}).toString();

	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		cardLayoutSettingPageEntryPoint,
		{ boardId: boardAri },
	);

	useEffect(() => {
		entryPointActions.load();
		return () => {
			entryPointActions.unload();
		};
	}, [entryPointActions]);

	const {
		id: rapidViewId,
		canEdit,
		showDaysInColumn,
		isKanPlanEnabled,
		isSprintSupportEnabled,
	} = props;

	return (
		<JiraEntryPointContainer
			id="jira-card-layout-setting-page"
			packageName="cardLayoutSettings"
			teamName="a4t-pandora"
			entryPointReferenceSubject={entryPointReferenceSubject}
			runtimeProps={{
				rapidViewId,
				canEdit,
				showDaysInColumn,
				isKanPlanEnabled,
				isSprintSupportEnabled,
			}}
			fallback={null}
		/>
	);
};

export default CardLayoutSettingsPage;
